export const IS_PROD = import.meta.env.PROD;
export const IS_DEV = !import.meta.env.PROD;
export const BASE_URL = import.meta.env.BASE_URL;
export const BUILD_ENV = BASE_URL !== '/' ? 'embedded' : 'standalone';
// export const BUILD_ENV = 'embedded';
export const BUILD_EMBED_TYPE =
  BUILD_ENV === 'embedded' ? (BASE_URL.startsWith('/') ? 'embed-web' : 'embed-native') : undefined;
export const BUILD_TIME = import.meta.env.BUILD_TIME as string;
export const KEY = import.meta.env.VITE_AES_KEY as string;
export const IV = import.meta.env.VITE_AES_IV as string;
export const APP_VERSION = import.meta.env.APP_VERSION as string;
export const COMMIT_HASH = import.meta.env.COMMIT_HASH as string;
export const APP_VERSION_HASH = `v${APP_VERSION}-${COMMIT_HASH.slice(0, 6)}-${BUILD_TIME}`;

export const STORAGE_KEY_PREFIX = 'chat-store';
export const QUERIES_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/queries`;
export const LOCALE_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/locale`;
export const AUTH_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/auth`;
export const CONFIGURATION_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/configuration`;
export const SESSIONS_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/sessions`;
export const DEVICE_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/device`;
export const EMBED_RELOAD_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/embed-reload`;
export const FRIEND_REQUEST_ID_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/read-friend-request-id`;
export const PERIODIC_MESSAGES_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/periodic-messages`;
export const SEARCH_HISTORY_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/search-history`;
export const REDIRECT_TO_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/redirect-to`;
export const DISPLAY_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/display`;
export const BRAND_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/brand`;
export const EXTRAS_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/extras`;
export const FILE_ENDPOINTS_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/file-endpoints`;
export const TRIGGER_SOUND_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/trigger-sound`;
export const LAST_UPDATE_VERSION_STORAGE_KEY = `${STORAGE_KEY_PREFIX}/did-update`;
